export const CONTRACT_TYPES = {
  MARGIN_OVERRIDE: 'margin_rates',
  RATE_OVERRIDE: 'fixed_rates',
};

export default CONTRACT_TYPES;
